import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CfIconDirective } from '@cf/shared/ui/icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSvgSpriteFragment } from 'ngxtension/svg-sprite';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'div[cf-modal-header]',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, NgxSvgSpriteFragment, CfIconDirective],
})
export class ModalHeaderComponent {
  @Input() heading!: string;

  @Input() hideCloseButton!: boolean;

  @Input() headingClass!: string;

  @Output() emitDismiss = new EventEmitter();

  constructor(public activeModal: NgbActiveModal) {}
}
